<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-file
                        :validations="validations.arquivo"
                        accept=".zip"
                        label="Arquivo"
                        v-model="model.arquivo"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('integracao-endereco-form')
        },
        validations() {
            return {
                arquivo: {required: true},
            }
        },
    },
    data: () => ({
        model: {
            arquivo: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('integracao-endereco-form')

                        const request = new FormData()

                        request.append('arquivo', this.model.arquivo)

                        this.repositories.integracao.endereco.store(request, {'Content-Type': 'multipart/form-data'})
                            .then(({data}) => this.$emit('save', data))
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading('integracao-endereco-form'))
                    }
                })
        },
    },
    mixins: [error],
}
</script>